export default function Privacidade() {
  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-20 max-w-4xl">
      <h1 className="text-4xl font-heading font-bold mb-8">Política de Privacidade</h1>
      <div className="prose prose-slate dark:prose-invert max-w-none space-y-6">
        <p className="text-muted-foreground">
          Na LEILIZE, levamos sua privacidade a sério. Esta política descreve como coletamos, usamos e protegemos suas informações.
        </p>
        
        <h2 className="text-2xl font-heading font-bold mt-8">1. Informações Coletadas</h2>
        <p>Coletamos apenas informações essenciais para fornecer nossos serviços, incluindo dados de veículos consultados e histórico de análises.</p>
        
        <h2 className="text-2xl font-heading font-bold mt-8">2. Uso das Informações</h2>
        <p>Utilizamos seus dados para melhorar nossos algoritmos e oferecer análises mais precisas. Nunca compartilhamos informações pessoais com terceiros.</p>
        
        <h2 className="text-2xl font-heading font-bold mt-8">3. Segurança</h2>
        <p>Implementamos medidas de segurança robustas para proteger seus dados contra acesso não autorizado.</p>
      </div>
    </div>
  );
}
